"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100vw',
    marginTop: '-5px',
    minHeight: '200px'
  },
  buttonGroupContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0 4vh 0',
    maxWidth: '1000px',
    '@media (max-width: 767px)': {
      maxWidth: '100vw'
    }
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: '5px 10px',
    paddingLeft: '20px',
    borderRadius: '75px',
    width: '375px',
    minHeight: '85px',
    WebkitTransition: '.5s all',
    transition: '.5s all',
    whiteSpace: 'nowrap',
    border: 'none',
    fontSize: '1.8rem',
    '@media (max-width: 767px)': {
      fontSize: '1.4rem',
      width: '90vw',
      minHeight: '65px'
    }
  },
  buttonIcon: {
    fontSize: '1.75rem',
    minWidth: '80px'
  },
  textContainer: {
    margin: '5vh 0 20px 0'
  },
  text: {
    fontSize: '1.6rem',
    fontWeight: '600',
    '@media (max-width: 767px)': {
      fontSize: '1.4rem',
      fontWeight: '400'
    }
  },
  lightBlue: {
    color: 'white',
    backgroundColor: '#64c3e4'
  },
  blue: {
    color: 'white',
    backgroundColor: '#2670c5'
  },
  darkBlue: {
    color: 'white',
    backgroundColor: '#092c7e'
  },
  red: {
    color: 'white',
    backgroundColor: '#f80000'
  },
  blueish: {
    color: 'black',
    backgroundColor: 'rgb(140, 191, 250)'
  },
  green: {
    color: 'black',
    backgroundColor: 'rgb(81, 210, 194)'
  },
  purple: {
    color: 'black',
    backgroundColor: 'rgb(214, 102, 205)'
  },
  orange: {
    color: 'black',
    backgroundColor: 'rgb(252, 171, 82)'
  },
  lime: {
    color: 'black',
    backgroundColor: 'rgb(126, 211, 33)'
  },
  yellow: {
    color: 'black',
    backgroundColor: 'rgb(248, 232, 27)'
  },
  // Wiki
  b1: {
    color: 'white',
    backgroundColor: 'rgb(99,195,227)'
  },
  b2: {
    color: 'white',
    backgroundColor: 'rgb(39,112,197)'
  },
  b3: {
    color: 'white',
    backgroundColor: 'rgb(47,138,181)'
  },
  b4: {
    color: 'white',
    backgroundColor: 'rgb(9,44,126)'
  },
  hover: {
    cursor: 'pointer',
    WebkitBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    MozBoxShadow: '0px 5px 40px -10px rgba(0,0,0,0.57)',
    boxShadow: '5px 40px -10px rgba(0,0,0,0.57)',
    transition: 'all 0.7s ease',
    fontSize: '1.6rem'
  }
};
exports.default = _default;

//# sourceMappingURL=FlowPage.css.js.map